<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/GeneralCodes">General Codes</b-breadcrumb-item>
            <b-breadcrumb-item active>{{entity}}</b-breadcrumb-item>
        </b-breadcrumb>

        <AppLoadingContainer :predicate="!isLoaded">
            <form @submit.prevent="onSubmit()">
                <div class="card">
                    <div class="bg-dark card-header text-white">Edit General Code</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 col-sm-12 form-group">
                                <label for="Entity">Entity</label>
                                <input class="form-control" disabled
                                       placeholder="Entity Name" v-model="generalCode.entity"/>
                            </div>
                            <div class="col-md-6 col-sm-12 form-group">
                                <label for="EntityShortDescription">Entity Short Description</label>
                                <input class="form-control" disabled
                                       placeholder="Entity Short Description"
                                       v-model="generalCode.entityShortDescription"/>
                            </div>
                            <div class="col-md-6 col-sm-12 form-group">
                                <label for="Code">Code</label>
                                <input :class="{'is-invalid': $v.generalCode.code.$invalid}" autocomplete="off"
                                       class="form-control" maxlength="15"
                                       placeholder="Code"
                                       v-model="generalCode.code"/>
                                <span class="invalid-feedback" v-if="!$v.generalCode.code.maxLength">ECode must be &le; 15 characters</span>
                            </div>
                            <div class="col-md-6 col-sm-12 form-group">
                                <label for="GroupingCode">Grouping Code</label>
                                <input :class="{'is-invalid': $v.generalCode.groupingCode.$invalid}"
                                       autocomplete="off"
                                       class="form-control"
                                       maxlength="10"
                                       placeholder="Grouping Code" v-model="generalCode.groupingCode"/>
                                <span class="invalid-feedback" v-if="!$v.generalCode.groupingCode.maxLength">Grouping code must be &le; 10 characters</span>
                            </div>
                            <div class="col-sm-12 form-group">
                                <label for="ShortDescription">Short Description</label>
                                <input :class="{'is-invalid': $v.generalCode.shortDescription.$invalid}"
                                       autocomplete="off"
                                       class="form-control"
                                       maxlength="255"
                                       placeholder="Short Description" v-model="generalCode.shortDescription"/>
                                <span class="invalid-feedback"
                                      v-if="!$v.generalCode.shortDescription.required">Field is required</span>
                                <span class="invalid-feedback" v-if="!$v.generalCode.shortDescription.maxLength">Short description must be &le; 255 characters</span>
                            </div>
                            <div class="col-sm-12 form-group">
                                <label for="LongDescription">Long Description</label>
                                <textarea :class="{'is-invalid': $v.generalCode.longDescription.$invalid}"
                                          autocomplete="off" class="form-control"
                                          maxlength="2000"
                                          placeholder="Long Description"
                                          v-model="generalCode.longDescription"></textarea>
                                <span class="invalid-feedback" v-if="!$v.generalCode.longDescription.maxLength">Long description must be &le; 2000 characters</span>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer d-print-none text-right">
                        <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
                        <RouterLink :to="{name:'GeneralCodes'}" class="btn btn-danger">Back</RouterLink>
                    </div>
                </div>
            </form>
        </AppLoadingContainer>

    </div>
</template>

<script>
    import {maxLength, required} from "vuelidate/lib/validators";
    import GeneralCodeService from "@/services/GeneralCodeService";
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
    import {ToastType} from "@/services/models/shared/ToastType";

    export default {
        components: {
            AppLoadingContainer
        },
        data() {
            return {
                generalCode: {},
                isSubmitting: false,
                isLoaded: false
            }
        },
        props: {
            entity: {
                type: String,
                required: false
            }
        },
        methods: {
            /**
             * @description Updates a general code and redirects if successful
             */
            onSubmit() {
                const vm = this;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;
                GeneralCodeService.updateGeneralCode(vm.generalCode).then(() => {
                    vm.alert(ToastType.Success, `The general code '${vm.generalCode.code} was successfully updated.`);

                    // Redirect to the general codes page
                    vm.$router.push({name: 'GeneralCodes'})
                }).catch(function (error) {
                    vm.alert(ToastType.Danger, error.response.statusText)
                }).finally(() => {
                    vm.isSubmitting = false;
                });
            }
        },
        created() {
            const id = this.$route.params.id;
            const vm = this;

            // Retrieve this specific general code
            GeneralCodeService.getGeneralCode(id)
                .then(function (response) {
                    vm.generalCode = response;
                }).catch(() => {
                vm.redirectToError()
            }).finally(() => vm.isLoaded = true);
        },
        validations: {
            generalCode: {
                shortDescription: {
                    required,
                    maxLength: maxLength(255)
                },
                longDescription: {
                    maxLength: maxLength(2000)
                },
                groupingCode: {
                    maxLength: maxLength(10)
                },
                code: {
                    maxLength: maxLength(15)
                }
            }
        }
    }
</script>
